import React from "react";
import { TableContentWrapper } from "./Styles";

const TableContent = (props) => {
  return <TableContentWrapper>{props.children}</TableContentWrapper>;
};

export default TableContent;
